import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserService } from '../../services/user-service/user.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  if(!req.url.includes(`${environment.API_ENDPOINT}`)){
    return next(req);
  }

  const userService = inject(UserService);
  const currentState = userService.getUserState();
  if (currentState.token) {
    const authRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${currentState.token}`
      }
    });
    return next(authRequest);
  }

  // If no token, forward request normally
  return next(req);
};
